import axios from 'axios';
import { Dispatch } from 'redux';
// Jeton de session joint aux appels de recrutement : ces routes exigent desormais d'etre
// connecte sur SON dossier (audit securite 2026-10-12). Lu au moment de l'appel, car
// l'inscription le pose juste avant.
const authHeaders = () => {
  const token = typeof window !== 'undefined' ? localStorage.getItem('access_token') : null;
  return token ? { headers: { Authorization: `Bearer ${token}` } } : {};
};


// Action Types
const SET_FORM_DATA = 'SET_FORM_DATA';
const SET_CMS_ANSWER = 'SET_CMS_ANSWER';
const SET_GUIDE_PREFERENCES = 'SET_GUIDE_PREFERENCES';
const UPDATE_CMS_ANSWERS_REQUEST = 'UPDATE_CMS_ANSWERS_REQUEST';
const UPDATE_CMS_ANSWERS_SUCCESS = 'UPDATE_CMS_ANSWERS_SUCCESS';
const UPDATE_CMS_ANSWERS_FAILURE = 'UPDATE_CMS_ANSWERS_FAILURE';
const FETCH_RECRUITMENT_INFO_REQUEST = 'FETCH_RECRUITMENT_INFO_REQUEST';
const FETCH_RECRUITMENT_INFO_SUCCESS = 'FETCH_RECRUITMENT_INFO_SUCCESS';
const FETCH_RECRUITMENT_INFO_FAILURE = 'FETCH_RECRUITMENT_INFO_FAILURE';
const UPDATE_RECRUITMENT_STATUS_REQUEST = 'UPDATE_RECRUITMENT_STATUS_REQUEST';
const UPDATE_RECRUITMENT_STATUS_SUCCESS = 'UPDATE_RECRUITMENT_STATUS_SUCCESS';
const UPDATE_RECRUITMENT_STATUS_FAILURE = 'UPDATE_RECRUITMENT_STATUS_FAILURE';
const UPDATE_USER_STATUS_REQUEST = 'UPDATE_USER_STATUS_REQUEST';
const UPDATE_USER_STATUS_SUCCESS = 'UPDATE_USER_STATUS_SUCCESS';
const UPDATE_USER_STATUS_FAILURE = 'UPDATE_USER_STATUS_FAILURE';
const UPDATE_GUIDE_PREFERENCES_REQUEST = 'UPDATE_GUIDE_PREFERENCES_REQUEST';
const UPDATE_GUIDE_PREFERENCES_SUCCESS = 'UPDATE_GUIDE_PREFERENCES_SUCCESS';
const UPDATE_GUIDE_PREFERENCES_FAILURE = 'UPDATE_GUIDE_PREFERENCES_FAILURE';
const UPLOAD_IMAGE_REQUEST = 'UPLOAD_IMAGE_REQUEST';
const UPLOAD_IMAGE_SUCCESS = 'UPLOAD_IMAGE_SUCCESS';
const UPLOAD_IMAGE_FAILURE = 'UPLOAD_IMAGE_FAILURE';
const UPDATE_AUDIO_RECORDING = "UPDATE_AUDIO_RECORDING"; // New action type for updating audio recordings
const UPLOAD_AUDIO_REQUEST = "UPLOAD_AUDIO_REQUEST"; // New action type for uploading audio
const UPLOAD_AUDIO_SUCCESS = "UPLOAD_AUDIO_SUCCESS"; // New action type for successful audio upload
const UPLOAD_AUDIO_FAILURE = "UPLOAD_AUDIO_FAILURE";

// RecruitmentState Interface
interface RecruitmentState {
  recruitmentData: any[];
  formData: {
    lastName: string;
    firstName: string;
    gender:string;
    birthdate:string;
    phone: string;
    email: string;
    confirmEmail: string;
    password: string;
    confirmPassword: string;
    city: string;
    bikeTour: string;
    carTour: string;
    language: number;
    spokenLanguages: string[];
    role:number;
    termsAccepted: boolean;
  };
  cmsAnswers: { [key: string]: string };
  guidePreferences: { [question: string]: { [label: string]: boolean } };
  loading: boolean;
  error: string | null;
  uploadedImageUrl: null, // Add this property
  uploadFileLoading: false,
  uploadFileError: null,
  audioRecordings: { [question: string]: Blob }; // Object to store audio recordings by question
  audioUrls: { [question: string]: string | null };
}

// Initial State
const initialState: RecruitmentState = {
  recruitmentData: [],
  formData: {
    lastName: '',
    firstName: '',
    birthdate: '',
    gender: 'M',
    phone: '',
    email: '',
    confirmEmail: '',
    password: '',
    confirmPassword: '',
    city: '-1',
    bikeTour: 'no',
    carTour: 'no',
    language: -1,
    spokenLanguages: [],
    role:3,
    termsAccepted: false,
  },
  cmsAnswers: {},
  guidePreferences: {},
  loading: false,
  error: null,
  uploadedImageUrl: null, // Add this property
  uploadFileLoading: false,
  uploadFileError: null,
  audioRecordings: {}, // Object to store audio recordings by question
  audioUrls: {},     
};

// Action Creators
export const setFormData = (field: string, value: any) => ({
  type: SET_FORM_DATA,
  payload: { field, value },
});

// Action Creator for Setting a CMS Answer
export const setCmsAnswer = (question: string, answer: string) => ({
  type: SET_CMS_ANSWER,
  payload: { question, answer },
});

export const setGuidePreferences = (questionKey: string, label: string, isChecked: boolean) => ({
  type: 'SET_GUIDE_PREFERENCES',
  payload: { questionKey, label, isChecked },
});

export const updateCmsAnswersRequest = () => ({
  type: UPDATE_CMS_ANSWERS_REQUEST,
});

export const updateCmsAnswersSuccess = (cmsAnswers: any) => ({
  type: UPDATE_CMS_ANSWERS_SUCCESS,
  payload: cmsAnswers,
});

export const updateCmsAnswersFailure = (error: string) => ({
  type: UPDATE_CMS_ANSWERS_FAILURE,
  payload: error,
});

export const fetchRecruitmentInfoRequest = () => ({
  type: FETCH_RECRUITMENT_INFO_REQUEST,
});

export const fetchRecruitmentInfoSuccess = (recruitmentInfo: any) => ({
  type: FETCH_RECRUITMENT_INFO_SUCCESS,
  payload: recruitmentInfo,
});

export const fetchRecruitmentInfoFailure = (error: string) => ({
  type: FETCH_RECRUITMENT_INFO_FAILURE,
  payload: error,
});

export const updateRecruitmentStatusRequest = () => ({
  type: UPDATE_RECRUITMENT_STATUS_REQUEST,
});

export const updateRecruitmentStatusSuccess = (status: string) => ({
  type: UPDATE_RECRUITMENT_STATUS_SUCCESS,
  payload: status,
});

export const updateRecruitmentStatusFailure = (error: string) => ({
  type: UPDATE_RECRUITMENT_STATUS_FAILURE,
  payload: error,
});

export const updateUserStatusRequest = () => ({
  type: UPDATE_USER_STATUS_REQUEST,
});

export const updateUserStatusSuccess = (status: string) => ({
  type: UPDATE_USER_STATUS_SUCCESS,
  payload: status,
});

export const updateUserStatusFailure = (error: string) => ({
  type: UPDATE_USER_STATUS_FAILURE,
  payload: error,
});

export const updateGuidePreferencesRequest = () => ({
  type: UPDATE_GUIDE_PREFERENCES_REQUEST,
});

export const updateGuidePreferencesSuccess = (guidePreferences: { [question: string]: { [label: string]: boolean } }) => ({
  type: UPDATE_GUIDE_PREFERENCES_SUCCESS,
  payload: guidePreferences,
});

export const updateGuidePreferencesFailure = (error: string) => ({
  type: UPDATE_GUIDE_PREFERENCES_FAILURE,
  payload: error,
});

export const uploadFileRequest = () => ({
  type: 'UPLOAD_IMAGE_REQUEST',
});

export const uploadFileSuccess = (imageUrl: string) => ({
  type: 'UPLOAD_IMAGE_SUCCESS',
  payload: imageUrl,
});

export const uploadFileFailure = (error : string) => ({
  type: 'UPLOAD_IMAGE_FAILURE',
  payload: error,
});

// Action Creator to add audio recordings to Redux
export const updateAudioRecording = (questionKey: string, audioData: string) => {
  return {
    type: 'UPDATE_AUDIO_RECORDING',
    payload: {
      questionKey,
      audioData, // Store the audio data as a string
    },
  };
};

// Action Creator for uploading audio
export const uploadAudioRequest = () => ({
  type: UPLOAD_AUDIO_REQUEST,
});

export const uploadAudioSuccess = (questionKey: string, audioBlob: Blob) => ({
  type: UPLOAD_AUDIO_SUCCESS,
  payload: { questionKey, audioBlob },
});

export const uploadAudioFailure = (error: string) => ({
  type: UPLOAD_AUDIO_FAILURE,
  payload: error,
});


export const updateAnswers = (uuid: string, cmsAnswers: { [key: string]: string }) => async (dispatch: Dispatch<any>) => {
  dispatch(updateCmsAnswersRequest());
console.log('updateAnswers', uuid, cmsAnswers)
  try {
    const response = await axios.put(`${process.env.NEXT_PUBLIC_SOCKET}/api/recruitment/${uuid}/cmsAnswers`, cmsAnswers, authHeaders());
    dispatch(updateCmsAnswersSuccess(response.data.cmsAnswers));
    // Optionally, handle any post-update logic or dispatch other actions as needed
  } catch (error: any) {
    const errorMessage = error.response?.data.message || 'Failed to update cmsAnswers';
    dispatch(updateCmsAnswersFailure(errorMessage));
  }
};

export const fetchRecruitmentInfo = (uuid: string) => async (dispatch: Dispatch<any>) => {
  dispatch(fetchRecruitmentInfoRequest());

  try {
    const response = await axios.get(`${process.env.NEXT_PUBLIC_SOCKET}/api/recruitment/${uuid}`, authHeaders());
    dispatch(fetchRecruitmentInfoSuccess(response.data));
  } catch (error: any) {
    const errorMessage = error.response?.data.message || 'Failed to fetch recruitment info';
    dispatch(fetchRecruitmentInfoFailure(errorMessage));
  }
};

// Self-healing variant: fetch the recruitment record and, if the backend
// has none for this user (404), create it on the fly then re-fetch. The
// record is normally created by `register()` for role-3 guides, but if the
// backend doesn't echo role 3 (or that step failed), the record is missing
// and every later PUT (/picture, /audio, /status…) 404s with "No
// recruitment information found". Calling this on entering the flow keeps
// the photo (step 5) and audio (step 6) uploads working regardless.
export const ensureRecruitment = (
  uuid: string,
  bikeTour?: any,
  carTour?: any
) => async (dispatch: Dispatch<any>) => {
  dispatch(fetchRecruitmentInfoRequest());
  try {
    const response = await axios.get(`${process.env.NEXT_PUBLIC_SOCKET}/api/recruitment/${uuid}`, authHeaders());
    dispatch(fetchRecruitmentInfoSuccess(response.data));
  } catch (error: any) {
    if (error?.response?.status === 404) {
      // Try to create the record. This can race with register()'s own
      // createRecruitment (guide signup) and come back 500 "already exists"
      // — that's fine, we re-fetch below regardless. No auth header: the
      // endpoint is called unauthenticated (matching register()).
      try {
        await axios.post(`${process.env.NEXT_PUBLIC_SOCKET}/api/createRecruitment`, {
          uuid,
          bikeTour,
          carTour,
        }, authHeaders());
      } catch (postErr: any) {
        console.error(
          'ensureRecruitment: createRecruitment POST failed (may already exist)',
          postErr?.response?.status
        );
      }
      // Re-fetch — a parallel create may have produced the record even if
      // our own POST 500'd. Only fail if it's genuinely still missing.
      try {
        const created = await axios.get(`${process.env.NEXT_PUBLIC_SOCKET}/api/recruitment/${uuid}`, authHeaders());
        dispatch(fetchRecruitmentInfoSuccess(created.data));
      } catch (refetchErr: any) {
        dispatch(
          fetchRecruitmentInfoFailure(
            refetchErr?.response?.data?.message || 'Failed to create recruitment'
          )
        );
      }
    } else {
      dispatch(
        fetchRecruitmentInfoFailure(
          error?.response?.data?.message || 'Failed to fetch recruitment info'
        )
      );
    }
  }
};

export const updateRecruitmentStatus = (uuid: string, status: string) => async (dispatch: Dispatch<any>) => {
  dispatch(updateRecruitmentStatusRequest());

  try {
    const response = await axios.put(`${process.env.NEXT_PUBLIC_SOCKET}/api/recruitment/${uuid}/status`, { status }, authHeaders());
    dispatch(updateRecruitmentStatusSuccess(response.data.status));
    // Optionally, you might want to fetch updated recruitment info here or dispatch other actions
  } catch (error: any) {
    const errorMessage = error.response?.data.message || 'Failed to update recruitment status';
    dispatch(updateRecruitmentStatusFailure(errorMessage));
  }
};

export const updateUserStatus = (uuid: string, status: string) => async (dispatch: Dispatch<any>) => {
  const access_token = localStorage.getItem('access_token')!;
  dispatch(updateUserStatusRequest());

  try {
    console.log('updateUserStatus', uuid, status, access_token)
    const response = await axios.put(`${process.env.NEXT_PUBLIC_SOCKET}/api/user/${uuid}`, { status },  {
      headers: { Authorization: `Bearer ${access_token}` }
    });

    dispatch(updateUserStatusSuccess(response.data.status));
    // Optionally, you might want to fetch updated recruitment info here or dispatch other actions
  } catch (error: any) {
    const errorMessage = error.response?.data.message || 'Failed to update user status';
    dispatch(updateUserStatusFailure(errorMessage));
  }
};

export const updateGuidePreferences = (uuid: string, guidePreferences: { [question: string]: { [label: string]: boolean } }) => async (dispatch: Dispatch<any>) => {
  dispatch(updateGuidePreferencesRequest());

  try {
    const response = await axios.put(`${process.env.NEXT_PUBLIC_SOCKET}/api/recruitment/${uuid}/preferences`, guidePreferences, authHeaders());
    dispatch(updateGuidePreferencesSuccess(response.data.guidePreferences));
    // Optionally, handle any post-update logic or dispatch other actions as needed
  } catch (error: any) {
    const errorMessage = error.response?.data.message || 'Failed to update guide preferences';
    dispatch(updateGuidePreferencesFailure(errorMessage));
  }
};

export const uploadFile = (formData: FormData) => async (dispatch: Dispatch) => {
  const access_token = localStorage.getItem('access_token');
  dispatch(uploadFileRequest());
  //console.log('uploadFile check =======', formData.get('file'))
  try {
    const response = await axios.post(`${process.env.NEXT_PUBLIC_SOCKET}/api/s3/uploadFile`, formData, {
      headers: {
        Authorization: `Bearer ${access_token}`,
        'Content-Type': 'multipart/form-data',
      },
    });

    // Check if the upload was not successful
    if (!response.data.success) {
      throw new Error('File upload unsuccessful');
    }

    dispatch(uploadFileSuccess(response.data.fileUrl));
    const { contentType, fileUrl } = response.data;

    // Construct payload outside of the conditionals for clarity
    const uuid = formData.get('uuid');
    const questionKey = formData.get('name');
    let payload = {};
    let picture = {};
    let updateUrl = '';


    console.log('----------- contentType --------', response)
    // Extract the file extension
    const fileExtension = response.data.newGalleryEntry.path.split('.').pop()?.toLowerCase();


    if (fileExtension && ['jpg', 'jpeg', 'png', 'gif'].includes(fileExtension)) {
      payload = { pictureUrl: fileUrl };
      picture = { picture: fileUrl };
      updateUrl = `${process.env.NEXT_PUBLIC_SOCKET}/api/recruitment/${uuid}/picture`;
    } else if (fileExtension && ['mp3', 'wav', 'ogg'].includes(fileExtension)) {
      const questionKey = formData.get('name');
      payload = { audio: fileUrl, questionKey };
      updateUrl = `${process.env.NEXT_PUBLIC_SOCKET}/api/recruitment/${uuid}/audio`;
    }

    // Perform the update if a URL has been set
    if (updateUrl) {
      await axios.put(updateUrl, payload, {
        headers: { Authorization: `Bearer ${access_token}` }
      });
      //update user table
      await axios.put(`${process.env.NEXT_PUBLIC_SOCKET}/api/user/${uuid}`, picture, {
        headers: { Authorization: `Bearer ${access_token}` }
      });
      //console.log('URL updated successfully for', contentType);
    } else {
      console.log('No action taken for contentType:', contentType);
    }
    return { success: true, fileUrl, questionKey };
  } catch (error : any) {
    let errorMessage = 'Failed to upload file';
    if (error.response && error.response.data.message) {
      errorMessage = error.response.data.message;
    } else if (error.message) {
      errorMessage = error.message;
    }
    dispatch(uploadFileFailure(errorMessage));
    console.error(errorMessage);
    return { success: false, error: errorMessage };
  }
};

// Reducer
const recruitmentReducer = (state: RecruitmentState = initialState, action: any) => {
  switch (action.type) {
    case SET_FORM_DATA: {
      const { field, value } = action.payload;
      return {
        ...state,
        formData: {
          ...state.formData,
          [field]: value, // Dynamically update the field based on action payload
        },
      };
    }
    case SET_CMS_ANSWER: {
      const { question, answer } = action.payload;
      return {
        ...state,
        cmsAnswers: {
          ...state.cmsAnswers,
          [question]: answer, // Dynamically update the answer based on the question
        },
      };
    }
    case SET_GUIDE_PREFERENCES: {
      const { questionKey, label, isChecked } = action.payload;
      return {
        ...state,
        guidePreferences: {
          ...state.guidePreferences,
          [questionKey]: { ...state.guidePreferences[questionKey], [label]: isChecked },
        },
      };
    }
    case UPDATE_CMS_ANSWERS_REQUEST:
      // Optionally, set loading state
      return { ...state, loading: true };
    case UPDATE_CMS_ANSWERS_SUCCESS:
      // Update cmsAnswers with the payload if necessary
      return { ...state, loading: false, cmsAnswers: action.payload };
    case UPDATE_CMS_ANSWERS_FAILURE:
      // Optionally, update state to reflect the error
      return { ...state, loading: false, error: action.payload };
    case FETCH_RECRUITMENT_INFO_REQUEST:
      return { ...state, loading: true };
    case FETCH_RECRUITMENT_INFO_SUCCESS:
      // Check if payload contains cmsAnswers and directly set it to cmsAnswers in state
      const cmsAnswers = action.payload.cmsAnswers || {};
      const guidePreferences = action.payload.guidePreferences || {};
      const uploadedImageUrl = action.payload.picture || null;
      return { 
        ...state, 
        loading: false, 
        cmsAnswers,
        guidePreferences,
        uploadedImageUrl,
      };
    case FETCH_RECRUITMENT_INFO_FAILURE:
      return { ...state, loading: false, error: action.payload };
    case UPDATE_RECRUITMENT_STATUS_REQUEST:
      return { ...state, loading: true };
    case UPDATE_RECRUITMENT_STATUS_SUCCESS:
      // Assuming you want to update the status in your state
      // You might also want to update this in the recruitmentData object if it's stored there
      return { 
        ...state, 
        loading: false, 
        recruitmentData: {
          ...state.recruitmentData,
          status: action.payload,
        }
      };
    case UPDATE_RECRUITMENT_STATUS_FAILURE:
      return { ...state, loading: false, error: action.payload };
    case UPDATE_GUIDE_PREFERENCES_REQUEST:
      // Optionally, set loading state
      return { ...state, loading: true };
    case UPDATE_GUIDE_PREFERENCES_SUCCESS:
      // Update guidePreferences with the payload
      return { ...state, loading: false, guidePreferences: action.payload };
    case UPDATE_GUIDE_PREFERENCES_FAILURE:
      // Optionally, update state to reflect the error
      return { ...state, loading: false, error: action.payload };
    case UPLOAD_IMAGE_REQUEST:
      return { ...state, uploadFileLoading: true, uploadFileError: null };
    case UPLOAD_IMAGE_SUCCESS:
      return { ...state, uploadedImageUrl: action.payload, uploadFileLoading: false };
    case UPLOAD_IMAGE_FAILURE:
      return { ...state, uploadFileError: action.payload, uploadFileLoading: false };
    case UPDATE_AUDIO_RECORDING:
      return {
        ...state,
        audioRecordings: {
          ...state.audioRecordings,
          [action.payload.questionKey]: action.payload.audioData,
        },
      };
    case UPLOAD_AUDIO_REQUEST:
      return { ...state, uploadFileLoading: true, uploadFileError: null };
    case UPLOAD_AUDIO_SUCCESS: {
      const { questionKey, audioUrl } = action.payload;
      return {
        ...state,
        audioUrls: {
          ...state.audioUrls,
          [questionKey]: audioUrl,
        },
        uploadFileLoading: false,
      };
    }
    case UPLOAD_AUDIO_FAILURE: {
      return { ...state, uploadFileError: action.payload, uploadFileLoading: false };
    }
    default:
      return state;
    }
  };

export default recruitmentReducer;
